import continousIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/continous.webp';
import endToEndIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/end-to-end.webp';
import scalingIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/scaling.webp';
import teamIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/team.webp';
import timeIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/time.webp';
import transparencyIcon from '../../../public/webp/fromPNG/AlgeaTheme/services/transparency.webp';

export const DeliveryProcessData = {
  title: 'Discover our delivery process',
  description: `We follow industry standards and battle-tested practices to deliver value. Over the years, we’ve developed custom processes that help us become a reliable technology partner to our clients.`,
  items: [
    {
      img: endToEndIcon,
      title: 'End-to-end solutions development',
      description:
        'We take care of the entire development process, from ideation to execution and maintenance.',
    },
    {
      img: transparencyIcon,
      title: 'Full transparency',
      description:
        'We equip our clients with tools that enable easy monitoring of the development process.',
    },
    {
      img: teamIcon,
      title: 'Dedicated developers',
      description:
        'When teaming up with us, you get a team of developers who work on your project full-time.',
    },
    {
      img: continousIcon,
      title: 'Continuous delivery',
      description:
        'We deliver work in small iterations and regular cycles to enable product optimization.',
    },
    {
      img: timeIcon,
      title: 'Daily stand-up meetings',
      description:
        'Our teams follow the most productive practices of the agile methodology.',
    },
    {
      img: scalingIcon,
      title: 'Flexibility in scaling',
      description:
        'We can scale your development team up or down, depending on your project requirements.',
    },
  ],
};
